export const FETCH_GET_MODELS = 'FETCH_GET_MODELS'
export const FETCH_GET_MODELS_SUCCESS = 'FETCH_GET_MODELS_SUCCESS'
export const FETCH_GET_DATA_MODEL = 'FETCH_GET_DATA_MODEL'
export const FETCH_GET_DATA_MODEL_SUCCESS = 'FETCH_GET_DATA_MODEL_SUCCESS'
export const FETCH_GET_STATS_MODEL = 'FETCH_GET_STATS_MODEL'
export const FETCH_GET_STATS_MODEL_SUCCESS = 'FETCH_GET_STATS_MODEL_SUCCESS'
export const FETCH_GET_TREND_MODEL = 'FETCH_GET_TREND_MODEL'
export const FETCH_GET_TREND_MODEL_SUCCESS = 'FETCH_GET_TREND_MODEL_SUCCESS'
export const FETCH_ADD_MODEL = 'FETCH_ADD_MODEL'
export const FETCH_ADD_MODEL_SUCCESS = 'FETCH_ADD_MODEL_SUCCESS'
export const FETCH_EDIT_MODEL = 'FETCH_EDIT_MODEL'
export const FETCH_EDIT_MODEL_SUCCESS = 'FETCH_EDIT_MODEL_SUCCESS'
export const FETCH_DELETE_MODEL = 'FETCH_DELETE_MODEL'
export const FETCH_DELETE_MODEL_SUCCESS = 'FETCH_DELETE_MODEL_SUCCESS'
export const FETCH_VERSION_MODEL = 'FETCH_VERSION_MODEL'
export const FETCH_VERSION_MODEL_SUCCESS = 'FETCH_VERSION_MODEL_SUCCESS'
export const FETCH_DELETE_MODEL_INITIALIZE = 'FETCH_DELETE_MODEL_INITIALIZE'
export const FETCH_DELETE_VERSION_INITIALIZE = 'FETCH_DELETE_VERSION_INITIALIZE'
export const FETCH_GET_PING_MODEL = 'FETCH_GET_PING_MODEL'
export const FETCH_GET_PING_MODEL_SUCCESS = 'FETCH_GET_PING_MODEL_SUCCESS'

export const fetchGetModels = (payload) => {
    return {
        type: FETCH_GET_MODELS,
        payload: {
            params:{
                token: payload
            }
        }
    }
}

export const fetchGetDataModel = (token, idModel) => {
    // console.log(token, idModel)
    return {
        type: FETCH_GET_DATA_MODEL,
        payload: {
            params:{
                token: token,
                idModel: idModel
            }
        }
    }
}

export const fetchGetStatsModel = (token, idModel) => {
    // console.log(token, idModel)
    return {
        type: FETCH_GET_STATS_MODEL,
        payload: {
            params:{
                token: token,
                idModel: idModel
            }
        }
    }
}

export const fetchGetTrendModel = (token, idModel) => {
    // console.log(token, idModel)
    return {
        type: FETCH_GET_TREND_MODEL,
        payload: {
            params:{
                token: token,
                idModel: idModel
            }
        }
    }
}

export const fetchAddModel = (payload) => {
    console.log(payload)
    return {
        type: FETCH_ADD_MODEL,
        payload: {
            params:{
                token: payload.token,
                client_id: payload.client_id,
                model_id: payload.model_id,
                model_name: payload.model_name,
                description: payload.description,
                model_type: payload.model_type,
                // routing_table: payload.routing_table,
                model_url: payload.model_url
            }
        }
    }
}

export const fetchEditModel = (payload) => {
    console.log(payload)
    return {
        type: FETCH_EDIT_MODEL,
        payload: {
            params:{
                token: payload.token,
                client_id: payload.client_id,
                model_id: payload.model_id,
                model_name: payload.model_name,
                description: payload.description,
                model_type: payload.model_type,
                extra_info: payload.extra_info,
                plot_conf: payload.plot_conf,
                background_image: payload.background_image,
                routing_table: payload.routing_table,
                model_url: payload.model_url
            }
        }
    }
}

export const fetchDeleteModel = (payload) => {
    // console.log(payload)
    return {
        type: FETCH_DELETE_MODEL,
        payload: {
            params:{
                token: payload.token,
                client_id: payload.client_id,
                model_id: payload.model_id
            }
        }
    }
}

export const fetchVersionOperation = (payload) => {
    console.log(payload)
    return {
        type: FETCH_VERSION_MODEL,
        payload: {
            params:{
                token: payload.token,
                client_id: payload.client_id,
                model_id: payload.model_id,
                operation: payload.operation,
                pop_version_name: payload.pop_version_name,
                new_version: payload.new_version
            }
        }
    }
}

export const fetchDeleteModelInitialize = (payload) => {
    // console.log(payload)
    return {
        type: FETCH_DELETE_MODEL_INITIALIZE,
        payload: {
        }
    }
}

export const fetchDeleteVersionInitialize = () => {
    // console.log(payload)
    return {
        type: FETCH_DELETE_VERSION_INITIALIZE,
        payload: {
        }
    }
}

export const fetchGetPingModel = (token, userId, model_id) => {
    // console.log(token, userId, model_id)
    return {
        type: FETCH_GET_PING_MODEL,
        payload: {
            params:{
                token: token,
                user_id: userId,
                idModel: model_id
            }
        }
    }
}